var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { NumberField } from './NumberField';
import { StringField } from './StringField';
function getType(store, name) {
    // get the constructor
    var Constructor = Object.getPrototypeOf(store).constructor;
    // default value of the field
    var defaultValue = Constructor.defaultValues[name];
    if (typeof defaultValue === 'object') {
        // differentiate array vs obj
    }
    else {
        switch (typeof defaultValue) {
            case 'string':
                return 'string';
            case 'number':
                return 'number';
        }
    }
    return null;
}
export function AutoField(props) {
    // heuristic for deciding which field to render
    var type = getType(props.store, props.name);
    switch (type) {
        case 'string':
            return React.createElement(StringField, __assign({}, props));
        case 'number':
            return React.createElement(NumberField, __assign({}, props));
        default:
            return null;
    }
}
//# sourceMappingURL=AutoField.js.map